import cookie from 'js-cookie';
const userInfo = 'U-Info'

export const getToken = function() {
  return cookie.get('accessToken');
}
export const setToken = async function(token: any) {
  const status: any = await cookie.set('accessToken', token);

  return status
}
export const removeToken = function() {
  return cookie.remove('accessToken');
}
export const getBaseInfo = function() {
  return cookie.get('userInfo');
}
export const setBasic = function(token: any) {
  return cookie.set('userInfo', token);
}
export const removeBaseInfo = function() {
  return cookie.remove('userInfo');
}
